import { Toaster as Sonner, type ToasterProps } from 'sonner';

/** Standard notifications use Sonner styling; toast.custom cards provide their own surface. */
function Toaster({ theme = 'light', ...props }: ToasterProps) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      // The insets are inside the offsets rather than in a wrapper because
      // sonner writes these straight into `--offset-*` / `--mobile-offset-*`
      // and reads them back as plain `bottom`/`right`, so a calc() survives —
      // and the toaster is portalled to <body>, outside every shell that
      // already handles its own safe area. On a desktop browser both env()
      // terms resolve to 0px and these are the 20 they always were.
      offset={{
        bottom: 'calc(20px + env(safe-area-inset-bottom))',
        right: 'calc(20px + env(safe-area-inset-right))',
      }}
      // 90 at the bottom on a phone clears the bottom tab bar, which the toast
      // would otherwise sit on top of — the one control a cashier reaches for
      // to get away from whatever the toast is reporting. The tab bar is
      // `76px + env(safe-area-inset-bottom)` (nav/bottom-tabs.tsx), so the
      // inset has to be added here too or the toast lands ON the bar it was
      // measured to clear on every phone with a home indicator.
      //
      // ONE NUMBER COVERS BOTH SHELLS. The office grew the same bar out of the
      // same component, at the same height — that is why it was moved to
      // components/nav — so this offset did not have to learn a second value.
      // If either bar's height ever moves, this moves with it.
      mobileOffset={{ bottom: 'calc(90px + env(safe-area-inset-bottom))', left: 16, right: 16 }}
      {...props}
    />
  );
}

export { Toaster };
